export default __webpack_public_path__ + "static/上上芊 cover-12502a7e423a73043ea5339de08b0461.png";